import { createSlice } from "@reduxjs/toolkit";
import {
  fetchInvestors,
  addInvestor,
  updateInvestor,
  deleteInvestor,
} from "./investor.thunk";

const initialState = {
  investors: [],
  totalPages: 1,
  currentPage: 1,
  total: 0,
  limit: 10,
  loading: false,
  error: null,
  selectedInvestor: null,
};

const investorSlice = createSlice({
  name: "investors",
  initialState,

  reducers: {
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload;
    },
    setSelectedInvestor: (state, action) => {
      state.selectedInvestor = action.payload;
    },
    clearSelectedInvestor: (state) => {
      state.selectedInvestor = null;
    },
  },

  extraReducers: (builder) => {
    builder

      /* ===== FETCH ===== */
      .addCase(fetchInvestors.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchInvestors.fulfilled, (state, action) => {
        state.loading = false;
        state.investors = action.payload.data;
        state.totalPages = action.payload.meta.total_pages;
        state.total = action.payload.meta.total;
        state.limit = action.payload.meta.limit;
      })
      .addCase(fetchInvestors.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      /* ===== ADD ===== */
      .addCase(addInvestor.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(addInvestor.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      /* ===== UPDATE ===== */
      .addCase(updateInvestor.fulfilled, (state) => {
        state.loading = false;
      })

      /* ===== DELETE ===== */
      .addCase(deleteInvestor.fulfilled, (state, action) => {
        state.investors = state.investors.filter(
          (investor) => investor.id !== action.payload.id
        );
      });
  },
});

export const {
  setCurrentPage,
  setSelectedInvestor,
  clearSelectedInvestor,
} = investorSlice.actions;

export default investorSlice.reducer;